module.exports = __webpack_public_path__ + "static/alexa-headshot-web-min.a3d3538a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/alexa-headshot-web-min.jpg
// module id = 1041
// module chunks = 144251824217401